// img proxy處理
export const imgProxy = (image_url, rs = null, q = "80") => {
    const userAgnet = navigator.userAgent
    if (!image_url) {
      return ""
    }
    if (userAgnet.includes("AdsBot-Google")) {
      return image_url
    }
	  let processing_options = []
    if (rs != null) {
    	processing_options.push("rs:"+rs)
    }
    if (q != null) {
    	processing_options.push("q:"+q)
    }
    const processing_options_str = processing_options.join('/')
    if (processing_options_str) {
    	url = process.env.IMG_PROXY + '/unsafe/' + processing_options_str + '/plain/' + image_url
    } else {
    	url = process.env.IMG_PROXY + '/unsafe/plain/' + image_url
    }
    // console.debug("imgProxy", image_url)
	  return url
}
